import { render } from "./classLibraryDetail.vue?vue&type=template&id=37eefe5c&scoped=true"
import script from "./classLibraryDetail.vue?vue&type=script&lang=js"
export * from "./classLibraryDetail.vue?vue&type=script&lang=js"

import "./classLibraryDetail.vue?vue&type=style&index=0&id=37eefe5c&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37eefe5c"]])

export default __exports__